module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#rss",
      toString: function () {
        return this.url;
      }
    }